export const USER_FETCH_PROFILE_USER = "USER_FETCH_PROFILE_USER"
export const USER_FETCH_STATEMENT = "USER_FETCH_STATEMENT"
export const USER_FETCH_ACTIVITY = "USER_FETCH_ACTIVITY"
export const USER_FETCH_BALANCE = "USER_FETCH_BALANCE"
export const USER_RESET_PASSWORD = "USER_RESET_PASSWORD"
export const USER_LOGOUT = "USER_LOGOUT"
export const IS_AUTO_PRINT = "IS_AUTO_PRINT"
export const IS_ADD_TO_CART = "IS_ADD_TO_CART"